export function unSanitizeFirebaseKey(encodedKey: string): string {
  const replacer = (_match: string, p1: string): string => {
    const code = parseInt(p1, 16)
    return String.fromCharCode(code)
  }

  return encodedKey.replace(/%([0-9A-F]{2})/gi, replacer)
}
